import * as Types from './types';
import { actionTypes } from './constants';

export const setPageData = (data: { path: string; page: Types.IPageState }): Types.IFetchPageAction => ({
    type: actionTypes.PAGE_DATA_SET,
    payload: data
});

export const setPopupBackgroundPagePath = (path: string): Types.ISetPopupBackgroundPagePathAction => ({
    type: actionTypes.PAGE_POPUP_BG_PAGE_PATH_SET,
    payload: path
});

// action needed in case there is a component on the page which dynamically changes the URL of the page, like Sportsbook
export const setPopupDynamicPagePath = (path: string): Types.ISetPopupDynamicPagePathAction => ({
    type: actionTypes.PAGE_DYNAMIC_PAGE_PATH_SET,
    payload: path
});

export const togglePageRendering = (isRendering: boolean): Types.ITogglePageRenderingAction => ({
    type: actionTypes.PAGE_RENDERING_TOGGLE,
    payload: isRendering
});

export const togglePageRendered = (isRendered: boolean): Types.ITogglePageRenderedAction => ({
    type: actionTypes.PAGE_RENDERED_TOGGLE,
    payload: isRendered
});
